<header>
  <bo-header />
</header>

<main>
  <bo-toast />
  <bo-navigation />
  <div class="bo-main-container">
    <router-outlet />
  </div>
</main>
